<template>
    <div class="side-view-self-translation-toggle">
        <div
            :class="{ 'side-view-self-translation-toggle__item': true, 'side-view-self-translation-toggle__item--active': !value }"
            @click="toggleStatus(false)"
        >
            <span>{{ $t('originalTransTitle') }}</span>
        </div>
        <div
            :class="{ 'side-view-self-translation-toggle__item': true, 'side-view-self-translation-toggle__item--active': value }"
            @click="toggleStatus(true)"
        >
            <span>{{ transLangType === 'ORIGINAL' ? LANG_TRANS[transLang] : $t('translateTitle') }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { LANG_TRANS } from '@/domains/translation/constants';
import { useTranslationStates } from '@/composables/use-translation-states';
import { computed } from 'vue';

const props = defineProps<{
    value: boolean;
    side: 'left' | 'right';
}>();

const emit = defineEmits<{
    (event: 'change', value: boolean): void;
}>();

const { currentLanguageModes, currentTranslateLanguages } = useTranslationStates();

const transLang = computed(() => {
    return currentTranslateLanguages.value[props.side || 'left'];
});

const transLangType = computed(() => {
    return currentLanguageModes.value[props.side || 'left'];
});

function toggleStatus(value: boolean) {
    if (value === props.value) return;
    emit('change', value);
}
</script>

<style lang="scss">
.side-view-self-translation-toggle {
    .side-view-self-translation-toggle__item {
        @apply pa-inline-block pa-mr-3 pa-text-black pa-leading-[30px] pa-cursor-pointer pa-relative;
        &:hover {
            @apply pa-text-green-500;
        }
        &:last-of-type {
            @apply pa-mr-0;
        }
        &--active {
            @apply pa-text-green-500;
            &:after {
                @apply pa-absolute pa-bottom-0 pa-left-0 pa-w-full pa-h-1 pa-bg-green-500 pa-rounded;
                content: '';
            }
        }
    }
}
</style>
